"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrateToHoldingViewMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class MigrateToHoldingViewMapper {
    toDomain(result) {
        const migrateToHoldingView = lodash_1.default.get(result, "data.migrateToHoldingView");
        return Object.assign({}, migrateToHoldingView);
    }
}
exports.MigrateToHoldingViewMapper = MigrateToHoldingViewMapper;
